<script>
  import { createEventDispatcher } from "svelte";
  import { f7, Badge } from "framework7-svelte";

  export let status = "pending";
  export let userName = "User";
  export let disabled = false;

  const dispatch = createEventDispatcher();

  let currentStatus = (status || "pending").toLowerCase();
  let pendingStatus = currentStatus;
  let selectEl;

  $: currentStatus = (status || "pending").toLowerCase();

  const statusConfigs = {
    approved: {
      label: "Approved",
      color: "green",
      badgeClass: "badge-status-approved",
      hex: "#2e7d32",
    },
    pending: {
      label: "Pending",
      color: "orange",
      badgeClass: "badge-status-pending",
      hex: "#ed6c02",
    },
    incomplete: {
      label: "Incomplete",
      color: "red",
      badgeClass: "badge-status-incomplete",
      hex: "#d32f2f",
    },
    deleted: {
      label: "Deleted",
      color: "gray",
      badgeClass: "badge-status-deleted",
      hex: "#6c757d",
    },
  };

  function getStatusConfig(st) {
    return statusConfigs[st] || {
      label: st ? st.toUpperCase() : "Unknown",
      color: "gray",
      badgeClass: "badge-status-default",
      hex: "#6c757d",
    };
  }

  function handleSelectChange(e) {
    const newTarget = e.target.value;
    if (newTarget === currentStatus) return;

    const fromCfg = getStatusConfig(currentStatus);
    const toCfg = getStatusConfig(newTarget);

    const dialogHtml = `
      <div style="text-align: center; padding: 8px 0;">
        <p style="margin-bottom: 12px; font-size: 14px;">
          Are you sure you want to update account status for <strong>${userName}</strong>?
        </p>
        <div style="display: flex; align-items: center; justify-content: center; gap: 10px; margin: 12px 0;">
          <span style="background: ${fromCfg.hex}; color: white; padding: 4px 10px; border-radius: 12px; font-size: 12px; font-weight: bold;">
            ${fromCfg.label}
          </span>
          <span style="font-size: 16px; font-weight: bold;">➔</span>
          <span style="background: ${toCfg.hex}; color: white; padding: 4px 10px; border-radius: 12px; font-size: 12px; font-weight: bold;">
            ${toCfg.label}
          </span>
        </div>
      </div>
    `;

    f7.dialog.create({
      title: "Confirm Status Change",
      content: dialogHtml,
      buttons: [
        {
          text: "Cancel",
          color: "gray",
          onClick: () => {
            // Revert select dropdown to previous status
            if (selectEl) selectEl.value = currentStatus;
            pendingStatus = currentStatus;
          },
        },
        {
          text: "Confirm Change",
          bold: true,
          color: toCfg.color,
          onClick: () => {
            const prev = currentStatus;
            currentStatus = newTarget;
            dispatch("change", {
              previousStatus: prev,
              newStatus: newTarget,
            });
          },
        },
      ],
      on: {
        close: () => {
          if (selectEl) selectEl.value = currentStatus;
        },
      },
    }).open();
  }
</script>

<div class="account-status-control-wrapper">
  <div class="status-badge-container">
    <span class="status-pill" style="background: {getStatusConfig(currentStatus).hex};">
      {getStatusConfig(currentStatus).label}
    </span>
  </div>

  <select
    bind:this={selectEl}
    value={currentStatus}
    on:change={handleSelectChange}
    class="status-dropdown-select"
    {disabled}
  >
    <option value="approved">Approved</option>
    <option value="pending">Pending</option>
    <option value="incomplete">Incomplete</option>
  </select>
</div>

<style>
  .account-status-control-wrapper {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    position: relative;
  }
  .status-pill {
    color: white;
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    display: inline-block;
  }
  .status-dropdown-select {
    padding: 4px 10px;
    border-radius: 6px;
    border: 1px solid #ced4da;
    background: #ffffff;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    outline: none;
    transition: border-color 0.15s ease-in-out;
  }
  .status-dropdown-select:focus {
    border-color: #2196f3;
  }
  .status-dropdown-select:disabled {
    background: #e9ecef;
    cursor: not-allowed;
  }
</style>
